module.exports = __webpack_public_path__ + "static/img/5.3631c3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/5.png
// module id = yhKX
// module chunks = 0